module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "joseph-knobel-freud.003069ad.jpeg" + "?" + Date.now();